import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { TopComponent } from './app_manager/top/top.component'
import { AuthService } from './services/auth.services'
import { AuthGuard } from './services/guarad/auth.guard'
import { LayoutPromotionComponent } from './promotion/layout-promotion/layout-promotion.component'
import { PromotionModule } from './promotion/promotion.module'
import { AppComponent } from './app.component'
import { AppElementModule } from './app_manager/app_element/appElement.module'
import { ClientComponent } from './app_manager/app_element/client/client.component'
import { ClientModule } from './app_manager/app_element/client/client.module'
import { StatusComponent } from './app_manager/app_element/status/status.component'
import { SettingComponent } from './app_manager/app_element/setting/setting.component'
import { StatusModule } from './app_manager/app_element/status/status.module'
import { SettingModule } from './app_manager/app_element/setting/setting.module'
import { PendingChangesGuard } from './services/guarad/pending-changes.guard'
import { CommunicationComponent } from './app_manager/app_element/communication/communication.component'
import { CommunicationModule } from './app_manager/app_element/communication/communication.module'
import { CommunicationRoomComponent } from './app_manager/app_element/communication-room/communication-room.component'
import { CommunicationRoomModule } from './app_manager/app_element/communication-room/communication-room.module'
import { ClientDetailComponent } from './app_manager/app_element/client-detail/client-detail.component'
import { ClientDetailModule } from './app_manager/app_element/client-detail/client-detail.module'
import { ClientAppComponent } from './client-app/client-app.component'
import { ClientAppModule } from './client-app/client-app.module'
import { LayoutAppNotFoundComponent } from './app_manager/app_element/layout-app-not-found/layout-app-not-found.component'

const routes: Routes = [
    // { path: '', component: PromotionComponent, pathMatch: 'full' },
    { path: '', component: LayoutPromotionComponent },
    { path: 'client', component: ClientAppComponent },
    // {path: 'client/:id', component: ClientAppComponent},
    {
        path: 'app',
        component: AppComponent,
        children: [
            { path: '', redirectTo: '/app/login', pathMatch: 'full' },
            { path: 'login', component: LoginComponent },
            { path: 'client', component: ClientAppComponent },
            { path: 'top', canActivate: [AuthGuard], component: TopComponent },
            { path: 'registration/:token', component: TopComponent },
            { path: 'main/status', component: StatusComponent },
            { path: 'main/communication', component: CommunicationComponent },
            { path: 'main/communication/room', component: CommunicationRoomComponent },
            { path: 'main/client', component: ClientComponent },
            { path: 'main/client/edit', component: ClientDetailComponent },
            { path: 'main/client/not-found', component: LayoutAppNotFoundComponent },

            {
                path: 'main/setting',
                canDeactivate: [PendingChangesGuard],
                component: SettingComponent,
            },
            { path: '**', component: LoginComponent },

        ],
    },
    { path: '**', redirectTo: '', pathMatch: 'full' },
]

@NgModule({
    imports: [RouterModule.forRoot(routes), PromotionModule, ClientModule, StatusModule, SettingModule, AppElementModule, CommunicationModule, CommunicationRoomModule, ClientDetailModule, ClientAppModule],
    providers: [AuthService],
    exports: [RouterModule],
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts